module.exports = __webpack_public_path__ + "static/assets/a3a60b80153f276afd415841ee9a8b40.png";